export default __webpack_public_path__ + "static/media/auth_photo.40daf842.jpg";